<nav class="navbar navbar-expand-lg navbar-dark bg-dark sticky-top" [ngStyle]="getNavbarStyle()">
    <div class="container-fluid">
        <a class="navbar-brand" routerLink="/">
            <img src="assets/img/niord_white.png" height="40" class="ms-2">
            <span class="mode-flag" *ngIf="mode == 'development'">DEV</span>
            <span class="mode-flag" *ngIf="mode == 'test'">TEST</span>
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <ul class="navbar-nav me-auto">
                <li class="nav-item">
                    <a class="nav-link" routerLink="messages" routerLinkActive="active" translate>menu.messages</a>
                </li>
                <li class="nav-item" *ngIf="domain && domain.atons">
                    <a class="nav-link" routerLink="atons" routerLinkActive="active" translate>menu.atons</a>
                </li>
                <li class="nav-item" *ngIf="hasRole('user')">
                    <a class="nav-link" routerLink="editor" routerLinkActive="active" translate>menu.editor</a>
                </li>
                <li class="nav-item" *ngIf="hasRole('admin')">
                    <a class="nav-link" routerLink="admin" routerLinkActive="active" translate>menu.admin</a>
                </li>
                <!-- 
                <li class="nav-item" *ngIf="isLoggedIn && domain && domain.firingSchedule">
                    <a class="nav-link" routerLink="schedule" routerLinkActive="active" translate>menu.schedule</a>
                </li>
                <li class="nav-item" *ngIf="hasRole('sysadmin')">
                    <a class="nav-link" routerLink="sysadmin" routerLinkActive="active" translate>menu.sysadmin</a>
                </li>
                -->
            </ul>

            <ul class="navbar-nav navbar-right">

                <li ngbDropdown class="nav-item clickable" display="dynamic">
                    <div ngbDropdownToggle id="domainDropdownMenuLink" class="nav-link">
                        <span *ngIf="domain">
                            <div *ngIf="domain.color" class="domain-color-badge"
                                [style]="{ 'background-color': domain.color }">
                            </div>
                            {{ domain.name }}
                        </span>
                        <span *ngIf="!domain" style="font-style: italic;">none</span>
                        <span *ngIf="domains.length" class="caret"></span>
                    </div>
                    <div ngbDropdownMenu *ngIf="domains.length" aria-labelledby="domainDropdownMenuLink">
                        <a ngbDropdownItem *ngFor="let d of domains" href (click)="changeDomain(d)" style="white-space: normal">
                            <fa-icon *ngIf="d.domainId == domain.domainId" [icon]="faCheck" class="menu-icon view-mode-menu-checkmark"></fa-icon>
                            <i *ngIf="d.domainId != domain.domainId" class="fa-none view-mode-menu-checkmark"></i>
                            &nbsp;{{d.name}}&nbsp;
                            <fa-icon *ngIf="d.editable" [icon]="faPencilAlt" class="menu-icon view-mode-menu-checkmark"></fa-icon>
                            <fa-icon *ngIf="!d.editable" [icon]="faEye" class="menu-icon view-mode-menu-checkmark"></fa-icon>
                        </a>
                    </div>
                </li>

                <li class="nav-item" *ngIf="!isLoggedIn">
                    <a class="nav-link clickable" [routerLink]=undefined (click)="login()" translate>menu.login</a>
                </li>

                <li ngbDropdown class="nav-item clickable" *ngIf="isLoggedIn" display="dynamic">
                    <div ngbDropdownToggle id="accountDropdownMenuLink" class="nav-link">
                        <fa-icon [icon]="faUser"></fa-icon>
                        <span class="caret"></span>
                    </div>
                    <div ngbDropdownMenu aria-labelledby="accountDropdownMenuLink">
                        <button ngbDropdownItem (click)="accountManagement()">
                            {{'view_mode.edit' |translate}} {{ userDesc }}
                        </button>
                        <button ngbDropdownItem (click)="logout()" translate>
                            menu.logout
                        </button>
                    </div>
                </li>

                <li ngbDropdown class="nav-item" *ngIf="siteLanguages.length > 1" display="dynamic">
                    <div ngbDropdownToggle id="languagetDropdownMenuLink" class="nav-link">
                        <flag [lang]="language" style="opacity: 0.5"></flag>
                        <span class="caret"></span>
                    </div>
                    <div ngbDropdownMenu aria-labelledby="languagetDropdownMenuLink">
                        <button ngbDropdownItem *ngFor="let lang of siteLanguages" (click)="changeLanguage(lang)">
                            <flag [lang]="lang"></flag> &nbsp; {{'lang.' + lang | translate}}
                        </button>
                    </div>
                </li>

            </ul>
        </div>
    </div>
</nav>

<help type="auto" section="home" class="auto-help-link"></help>